import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Page } from '../../components';
import { CardSmall, LabelIconText, CarouselSmall } from '../../ui';
import { productDataActions } from '../../store/actions';
import { IT } from 'country-flag-icons/react/3x2';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';

export function Shop() {
    const { categoryDict, categoryIDs, subCategoryDict } = useSelector(state => state.mainData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [search, setSearch] = React.useState('');
    const [idAdmitted, setIdAdmitted] = React.useState([]);
    const delaySearch = React.useRef(null);
    const askedToInstall = localStorage.getItem('askedToInstall') === 'true';

    const handleCardClick = (categoryId, subCategoryId) => {
        navigate(`/details?categoryId=${categoryId}&subCategoryId=${subCategoryId}`);
    }

    React.useEffect(() => {
        if (delaySearch.current)
            clearTimeout(delaySearch.current);
        delaySearch.current = setTimeout(() => {
            if (search.length > 0) {
                const newIdAdmitted = [];
                Object.keys(subCategoryDict).forEach((subCategoryId) => {
                    if (subCategoryDict[subCategoryId].name.toLowerCase().includes(search.toLowerCase())) {
                        newIdAdmitted.push(parseInt(subCategoryId));
                    }
                });
                if (newIdAdmitted.length === 0)
                    newIdAdmitted.push(-1);
                setIdAdmitted(newIdAdmitted);
            }
            else
                setIdAdmitted([]);
        }, 500);
    }, [search, subCategoryDict]);

    React.useEffect(() => {
        dispatch(productDataActions.unlockClean());
    }, [dispatch]);

    const checkIdsAdmitted = (subCategoryIds) => {
        if (idAdmitted.length > 0)
            return subCategoryIds.some((subCategoryId) => idAdmitted.includes(subCategoryId));
        else
            return true;
    }

    const checkSearchInTitle = (title) => {
        if (search.length > 0)
            return title.toLowerCase().includes(search.toLowerCase());
        else
            return true;
    }

    const noElementFound = idAdmitted.length === 1 && idAdmitted[0] === -1;

    return (
        <Page
            title={
                <div className='position-relative'>
                    <span className='opacity-0'>
                        Prodotti Kangury
                    </span>
                    <span className='fs-3 w-100 position-absolute top-50 start-50 translate-middle text-center'>
                        Prodotti Kangury
                    </span>
                </div>
            }
            simpleTitle={true}
        >
            <div className='p-3 pt-1'>
                <div className='w-100 text-center mt-0 mb-2'>
                    <IT style={{ height: '15px' }} /><em className='me-2 ms-2'>made in Italy</em><IT style={{ height: '15px' }} />
                </div>
                <div className='w-100 text-center mb-3 bg-primary p-2 rounded-3 lh-sm fs-6'>

                    Con ogni foto <strong>incluso uno spazio cloud privato</strong>, per sempre, <strong>senza costi ricorrenti!</strong> ed espandibile a piacere 
                    <br />
                    Raggiungibile anche sfiorando la foto con il tuo smartphone <br />
                </div>
                {noElementFound && <h4 className='w-100 text-center mt-3 text-danger'>
                    Nessun prodotto trovato, prova con una diversa ricerca
                </h4>}
                {!noElementFound && categoryIDs?.map((categoryId, index) => {
                    const searchedProduct = idAdmitted.length === 0 ? categoryDict[categoryId].subCategoryIDs
                        : categoryDict[categoryId].subCategoryIDs?.filter((subCategoryId) => idAdmitted.includes(subCategoryId) || checkSearchInTitle(categoryDict[categoryId].name));
                    const notCarouselElement = searchedProduct.filter((subCategoryId) => (subCategoryDict[subCategoryId].layoutType !== 2));
                    const carouselElement = searchedProduct.filter((subCategoryId) => subCategoryDict[subCategoryId].layoutType === 2);
                    return (checkIdsAdmitted(categoryDict[categoryId].subCategoryIDs) || checkSearchInTitle(categoryDict[categoryId].name)) ?
                        (<div className='row mt-3' key={index}>
                            <LabelIconText
                                text={categoryDict[categoryId].name}
                                otherClass="" />
                            {notCarouselElement.length > 0 && notCarouselElement.map((subCategoryId, index) => {
                                return <div onClick={() => handleCardClick(categoryId, subCategoryId)} key={index}
                                    className={`${subCategoryDict[subCategoryId].layoutType === 1 ? "col-12 col-sm-6 col-md-4" : "col-6 col-md-4"}`}>
                                    <CardSmall
                                        key={index}
                                        title={subCategoryDict[subCategoryId].name}
                                        image={subCategoryDict[subCategoryId].image}
                                        otherClass="cursor-pointer mb-3 mt-3"
                                    />
                                </div>
                            }
                            )}
                            {carouselElement.length > 0 &&
                                <CarouselSmall
                                    elements={carouselElement.map((subCategoryId, index) => {
                                        return <div onClick={() => handleCardClick(categoryId, subCategoryId)} key={index}
                                            className={`mb-4 mt-n1`}>
                                            <CardSmall
                                                key={index}
                                                title={subCategoryDict[subCategoryId].name}
                                                image={subCategoryDict[subCategoryId].image}
                                                otherClass="cursor-pointer mt-3 mb-3"
                                            />
                                        </div>
                                    })}
                                />}
                        </div>)
                        : null
                }
                )}
            </div>
            <div className='w-100 text-center fw-bold'>
                ...
            </div>
            <div className='p-3 mb-4'>
                <div className='card rounded-3 p-3 bg-tertiary bg-opacity-75 shadow'>
                    <div className='d-flex flex-column align-items-center text-center p-2'>
                        <BusinessCenterOutlinedIcon className='text-primary mb-2' style={{ fontSize: '36px' }} />
                        <div className='fw-bold text-primary fs-5 mb-1'>Sei un professionista?</div>
                        <div className='text-white mb-3 lh-sm'>
                            Scopri Kangury per il Business: gadget promozionali NFC per agenzie, eventi e aziende.
                        </div>
                        <button type="button"
                            className='btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4'
                            onClick={() => navigate('/business')}>
                            Scopri di più <ArrowForwardOutlinedIcon className='ms-1' style={{ fontSize: '18px' }} />
                        </button>
                    </div>
                </div>
            </div>
            <div className='w-100 text-center fw-bold mb-5 ps-2 pe-2'>
                Le funzionalità esistenti sono in continuo miglioramento e nuove altre arriveranno, ti ringraziamo per il tuo supporto
            </div>
        </Page >
    );
}
